var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusdeletedicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2461 2.00244C14.0475 2.92653 14.488 4.10915 14.4863 5.33238V7.15056C14.4863 7.35129 14.6492 7.5142 14.8499 7.5142H16.6681C17.8914 7.5125 19.074 7.95297 19.9981 8.75444C19.5714 7.13186 18.7215 5.6517 17.5352 4.46536C16.3488 3.27902 14.8687 2.42907 13.2461 2.00244Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81818 2C4.81358 2 4 2.81455 4 3.81818V20.5455C4 21.5491 4.81455 22.3636 5.81818 22.3636H18.1818C19.1855 22.3636 20 21.5491 20 20.5455V12.9091C20 11.9447 19.6169 11.0197 18.9349 10.3378C18.253 9.65584 17.3281 9.27273 16.3636 9.27273H14.5455C14.0632 9.27273 13.6008 9.08117 13.2598 8.74019C12.9188 8.39922 12.7273 7.93676 12.7273 7.45455V5.63636C12.7273 4.67194 12.3442 3.74702 11.6622 3.06507C10.9803 2.38312 10.0553 2 9.09091 2H5.81818ZM9.735 11.6098C9.40839 11.2832 8.87885 11.2832 8.55224 11.6098C8.22563 11.9364 8.22563 12.4659 8.55224 12.7925L10.8172 15.0575L8.55224 17.3225C8.22563 17.6491 8.22563 18.1787 8.55224 18.5053C8.87885 18.8319 9.40839 18.8319 9.735 18.5053L12 16.2403L14.265 18.5053C14.5916 18.8319 15.1211 18.8319 15.4477 18.5053C15.7744 18.1787 15.7744 17.6491 15.4477 17.3225L13.1828 15.0575L15.4477 12.7925C15.7744 12.4659 15.7744 11.9364 15.4477 11.6098C15.1211 11.2832 14.5916 11.2832 14.265 11.6098L12 13.8748L9.735 11.6098Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusdeletedicon);
export default __webpack_public_path__ + "static/media/statusdeleted.icon.fe20ce58f7ff099434a24ddb67060d98.svg";
export { ForwardRef as ReactComponent };